<template>
  <div class="incident-timeline">
    <!-- Status Bar -->
    <div class="status-bar">
      <span class="time">13:15</span>
      <div class="status-icons">
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none">
          <path d="M1 5.5C1 5.5 3.5 1 8.5 1C13.5 1 16 5.5 16 5.5C16 5.5 13.5 10 8.5 10C3.5 10 1 5.5 1 5.5Z" stroke="black" stroke-width="1.5"/>
          <circle cx="8.5" cy="5.5" r="2" stroke="black" stroke-width="1.5"/>
        </svg>
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none">
          <rect x="1" y="3" width="4" height="6" fill="black"/>
          <rect x="7" y="1" width="4" height="8" fill="black"/>
          <rect x="13" y="0" width="4" height="9" fill="black"/>
        </svg>
        <svg width="24" height="12" viewBox="0 0 24 12" fill="none">
          <rect x="1" y="3" width="18" height="6" rx="1" stroke="black"/>
          <rect x="20" y="5" width="3" height="2" fill="black"/>
          <rect x="2" y="4" width="16" height="4" fill="black"/>
        </svg>
        <span class="battery-percent">100</span>
      </div>
    </div>

    <!-- Header -->
    <div class="header">
      <button class="back-button" @click="$emit('navigate', 'details')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <h1 class="title">Fall in Car Park Requiring Medical Assistance</h1>
      <button class="menu-button">
        <svg width="4" height="18" viewBox="0 0 4 18" fill="none">
          <circle cx="2" cy="2" r="2" fill="#007AFF"/>
          <circle cx="2" cy="9" r="2" fill="#007AFF"/>
          <circle cx="2" cy="16" r="2" fill="#007AFF"/>
        </svg>
      </button>
    </div>

    <!-- Incident Info Card -->
    <div class="incident-card">
      <div class="incident-header">
        <span class="incident-number">4419</span>
        <span class="badge health-safety">Health & Safety</span>
        <span class="badge medical">Medical</span>
      </div>
      <div class="incident-status">
        <p class="status-label">Incident was closed after</p>
        <div class="timer">
          <div class="time-block">
            <span class="time-value">00</span>
            <span class="time-label">DAYS</span>
          </div>
          <div class="time-block">
            <span class="time-value">00</span>
            <span class="time-label">HOURS</span>
          </div>
          <div class="time-block">
            <span class="time-value">01</span>
            <span class="time-label">MIN</span>
          </div>
        </div>
        <button class="location-button">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="#007AFF" stroke-width="2"/>
            <circle cx="12" cy="10" r="3" stroke="#007AFF" stroke-width="2"/>
          </svg>
        </button>
      </div>
      <div class="opened-by">
        <img src="https://i.pravatar.cc/40?img=3" alt="Denis Murphy" class="avatar">
        <span>Opened By <strong>Denis Murphy</strong> @ 08 Jul, 08:29</span>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="weather-icon">
          <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41m11.32-11.32l1.41-1.41M12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12z" stroke="#FFB800" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span class="temperature">12°C</span>
      </div>
    </div>

    <!-- Timeline/Chat Section -->
    <div class="timeline-section">
      <div class="timeline-tabs">
        <button class="tab active">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M12 8v4l3 3" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/>
          </svg>
          Timeline
        </button>
        <button class="tab">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="currentColor" stroke-width="2"/>
            <path d="M14 2v6h6" stroke="currentColor" stroke-width="2"/>
          </svg>
        </button>
        <button class="tab">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M3 3h18v18H3V3z" stroke="currentColor" stroke-width="2"/>
            <path d="M3 9h18M9 21V9" stroke="currentColor" stroke-width="2"/>
          </svg>
        </button>
        <span class="message-count">3</span>
      </div>

      <div class="timeline-content">
        <div class="date-header">TUESDAY, 08 JUL</div>
        
        <div v-for="event in timelineEvents" :key="event.id" class="timeline-event">
          <div class="event-time">{{ event.time }}</div>
          <div class="event-marker" :class="event.type"></div>
          <div class="event-content">
            <div class="event-header">
              <img :src="event.avatar" :alt="event.author" class="event-avatar">
              <span><strong>{{ event.author }}</strong> {{ event.action }}</span>
            </div>
            <div v-if="event.alert" class="alert-message" :class="event.alertType">
              <div class="alert-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" fill="#DC3545"/>
                  <path d="M12 8v4m0 4h.01" stroke="white" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </div>
              <div class="alert-content">
                <div v-if="event.alertTitle" class="alert-title">{{ event.alertTitle }}</div>
                <div class="alert-text">{{ event.message }}</div>
                <div v-if="event.more" class="alert-more">
                  <span class="more-button">MORE</span>
                </div>
              </div>
            </div>
            <div v-else-if="event.message" class="event-message">
              {{ event.message }}
            </div>
            <div v-if="event.tags" class="event-tags">
              <span v-for="tag in event.tags" :key="tag" class="tag" :class="tag.toLowerCase().replace(/[^a-z]/g, '')">
                <svg v-if="tag === 'Health & Safety'" width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" fill="currentColor"/>
                </svg>
                <svg v-if="tag === 'Medical'" width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" fill="currentColor"/>
                </svg>
                <svg v-if="tag === 'Slip Trip Fall'" width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" fill="currentColor"/>
                </svg>
                {{ tag }}
              </span>
            </div>
            <div v-if="event.location" class="event-location">
              <div class="location-text">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M19 10.5c0 7.142-7 13-7 13s-7-5.858-7-13a7 7 0 1 1 14 0z" stroke="#007AFF" stroke-width="2"/>
                  <circle cx="12" cy="10.5" r="3" stroke="#007AFF" stroke-width="2"/>
                </svg>
                <span>Metro St - Mobile + Dash only</span>
              </div>
              <p class="location-address">{{ event.location.address }}</p>
              <div class="location-map">
                <img src="https://api.mapbox.com/styles/v1/mapbox/streets-v11/static/-1.6024,54.9619,15,0/300x150@2x?access_token=pk.eyJ1IjoidGVzdCIsImEiOiJjbGh5cWVkMzMwMGVlM2pvMGJyYzl3cGVxIn0.test" alt="Location map">
                <div class="map-marker"></div>
              </div>
            </div>
            <div v-if="event.image" class="event-image">
              <img :src="event.image" alt="Event image">
              <div v-if="event.imageHighlight" class="image-highlight" :style="{left: event.imageHighlight.x + '%', top: event.imageHighlight.y + '%'}"></div>
            </div>
            
            <!-- Blockchain Security Icon -->
            <div class="blockchain-security">
              <button 
                class="blockchain-icon" 
                @click="openBlockchainDrawer(event)"
                title="View blockchain transaction details"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#007AFF" stroke-width="2" stroke-linejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="#007AFF" stroke-width="2" stroke-linejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="#007AFF" stroke-width="2" stroke-linejoin="round"/>
                </svg>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" class="security-badge">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="#28A745" stroke="#28A745" stroke-width="2"/>
                  <path d="M9 12l2 2 4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Navigation -->
    <div class="bottom-nav">
      <div class="nav-input">
        <input type="text" placeholder="Add comment..." v-model="newMessage" @keyup.enter="sendMessage">
        <button class="attach-button">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" stroke="#8E8E93" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
        <button class="camera-button">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" stroke="#8E8E93" stroke-width="2"/>
            <circle cx="12" cy="13" r="4" stroke="#8E8E93" stroke-width="2"/>
          </svg>
        </button>
      </div>
      <div class="nav-buttons">
        <button class="nav-button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="#8E8E93" stroke-width="2"/>
            <path d="M9 22V12h6v10" stroke="#8E8E93" stroke-width="2"/>
          </svg>
        </button>
        <button class="nav-button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 11l3 3 3-3" stroke="#8E8E93" stroke-width="2" stroke-linecap="round"/>
            <circle cx="12" cy="12" r="10" stroke="#8E8E93" stroke-width="2"/>
          </svg>
        </button>
        <button class="nav-button active">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#007AFF"/>
          </svg>
          <span class="nav-badge">1</span>
        </button>
        <button class="nav-button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M4 12l8-8v6h8v4h-8v6z" stroke="#8E8E93" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="nav-button add-button">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="#007AFF" stroke-width="2"/>
            <path d="M12 8v8m-4-4h8" stroke="#007AFF" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Blockchain Transaction Drawer -->
    <div 
      v-if="drawerOpen" 
      class="drawer-overlay"
      @click="closeBlockchainDrawer"
    >
      <div 
        class="blockchain-drawer"
        @click.stop
        :class="{ 'drawer-open': drawerOpen }"
      >
        <div class="drawer-header">
          <button class="drawer-back-button" @click="closeBlockchainDrawer">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="#007AFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <h2 class="drawer-title">Transaction registered on the blockchain</h2>
        </div>
        
        <div class="drawer-content">
          <div class="blockchain-card">
            <div class="card-header">
              <div class="blockchain-icon-large">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#007AFF" stroke-width="2" stroke-linejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="#007AFF" stroke-width="2" stroke-linejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="#007AFF" stroke-width="2" stroke-linejoin="round"/>
                </svg>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="security-badge-large">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="#28A745" stroke="#28A745" stroke-width="2"/>
                  <path d="M9 12l2 2 4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <h3>Blockchain Transaction Details</h3>
            </div>
            
            <div class="transaction-details">
              <div class="detail-item">
                <label>Date and time:</label>
                <span>{{ selectedTransaction?.timestamp }}</span>
              </div>
              
              <div class="detail-item">
                <label>Transaction address:</label>
                <span class="address-text">{{ selectedTransaction?.address }}</span>
                <button class="copy-button" @click="copyToClipboard(selectedTransaction?.address)">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" stroke="currentColor" stroke-width="2"/>
                    <rect x="8" y="2" width="8" height="4" rx="1" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </button>
              </div>
              
              <div class="detail-item">
                <label>Transaction hash:</label>
                <span class="hash-text">{{ selectedTransaction?.hash }}</span>
                <button class="copy-button" @click="copyToClipboard(selectedTransaction?.hash)">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" stroke="currentColor" stroke-width="2"/>
                    <rect x="8" y="2" width="8" height="4" rx="1" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </button>
              </div>
              
              <div class="detail-item">
                <label>Transaction hash outside blockchain:</label>
                <span class="hash-text">{{ selectedTransaction?.hashOutside }}</span>
                <button class="copy-button" @click="copyToClipboard(selectedTransaction?.hashOutside)">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" stroke="currentColor" stroke-width="2"/>
                    <rect x="8" y="2" width="8" height="4" rx="1" stroke="currentColor" stroke-width="2"/>
                  </svg>
                </button>
              </div>
              
              <div class="detail-item">
                <label>Digital Certificate:</label>
                <div class="certificate-container">
                  <div class="certificate-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke="#007AFF" stroke-width="2"/>
                      <path d="M14 2v6h6" stroke="#007AFF" stroke-width="2"/>
                      <path d="M16 13H8" stroke="#007AFF" stroke-width="2"/>
                      <path d="M16 17H8" stroke="#007AFF" stroke-width="2"/>
                      <path d="M10 9H8" stroke="#007AFF" stroke-width="2"/>
                    </svg>
                  </div>
                  <div class="certificate-info">
                    <span class="certificate-name">{{ selectedTransaction?.certificate?.name }}</span>
                    <span class="certificate-issuer">Issued by: {{ selectedTransaction?.certificate?.issuer }}</span>
                    <span class="certificate-expires">Expires: {{ selectedTransaction?.certificate?.expires }}</span>
                  </div>
                </div>
              </div>
              
              <div class="security-status">
                <div class="security-indicator">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="#28A745" stroke="#28A745" stroke-width="2"/>
                    <path d="M9 12l2 2 4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span>Transaction Verified & Secured</span>
                </div>
                <p class="security-description">
                  This transaction has been cryptographically secured and permanently recorded on the blockchain, ensuring immutability and transparency.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue';

export default {
  name: 'IncidentTimeline',
  emits: ['navigate'],
  setup() {
    const newMessage = ref('');
    const drawerOpen = ref(false);
    const selectedTransaction = ref(null);
    
    // Generate blockchain transaction data for each event
    const generateBlockchainData = (eventId) => {
      const baseDate = new Date();
      const addresses = [
        '0x742d35Cc6634C0532925a3b8D1B9e4b1567e4F23',
        '0x8ba1f109551bD432803012645Hac136c22C85B1',
        '0x9f8a2c7b4e1d0f3a8c5b9e2d1f4a7c3e6b8d5f2a',
        '0x4e3b8d5f2a9c6e1f4a7b0d3c8e5f2a9c6e1f4a7b'
      ];
      
      const hashes = [
        '0xa7b3c2d1e4f5a6b7c8d9e0f1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1',
        '0xf2a9c6e1f4a7b0d3c8e5f2a9c6e1f4a7b0d3c8e5f2a9c6e1f4a7b0d3c8e5f2a9',
        '0x1c8e5f2a9c6e1f4a7b0d3c8e5f2a9c6e1f4a7b0d3c8e5f2a9c6e1f4a7b0d3c8e5',
        '0x7b0d3c8e5f2a9c6e1f4a7b0d3c8e5f2a9c6e1f4a7b0d3c8e5f2a9c6e1f4a7b0d3'
      ];
      
      return {
        id: eventId,
        timestamp: new Date(baseDate.getTime() + (eventId * 60000)).toLocaleString('en-GB', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }),
        address: addresses[eventId % addresses.length],
        hash: hashes[eventId % hashes.length],
        hashOutside: hashes[eventId % hashes.length], // Same as hash as requested
        certificate: {
          name: 'Incident Management Digital Certificate',
          issuer: 'Blockchain Certificate Authority',
          expires: new Date(baseDate.getTime() + (365 * 24 * 60 * 60 * 1000)).toLocaleDateString('en-GB')
        }
      };
    };
    
    const timelineEvents = reactive([
      {
        id: 1,
        time: '08:31',
        type: 'closed',
        author: 'Denis Murphy',
        action: 'closed incident',
        avatar: 'https://i.pravatar.cc/40?img=3',
        alert: true,
        alertType: 'danger',
        alertTitle: 'Generated by AI',
        message: 'A woman sustained a fall in a car park and required medical assistance. An ambulance was dispatched, with an estimated time of arrival of 20 minutes. First aiders were present at the scene while awaiting the a...',
        more: true,
        tags: ['Health & Safety', 'Medical', 'Slip Trip Fall']
      },
      {
        id: 2,
        time: '08:31',
        type: 'update',
        author: 'Colm Moran',
        action: 'updated incident',
        avatar: 'https://i.pravatar.cc/40?img=4',
        image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=300&h=200&fit=crop',
        imageHighlight: { x: 60, y: 70 }
      },
      {
        id: 3,
        time: '08:31',
        type: 'medical',
        author: 'Denis Murphy',
        action: 'updated incident',
        avatar: 'https://i.pravatar.cc/40?img=3',
        message: 'First Aid Form New\nCompleted by Denis Murphy @ 07:27',
        tags: ['Medical']
      },
      {
        id: 4,
        time: '08:30',
        type: 'response',
        author: 'Colm Moran',
        action: 'updated incident',
        avatar: 'https://i.pravatar.cc/40?img=4',
        message: '"First aiders on scene"'
      },
      {
        id: 5,
        time: '08:30',
        type: 'response',
        author: 'Colm Moran',
        action: 'updated incident',
        avatar: 'https://i.pravatar.cc/40?img=4',
        message: '"Call put in for ambulance. ETA 20 mins"'
      },
      {
        id: 6,
        time: '08:30',
        type: 'medical',
        author: 'Denis Murphy',
        action: 'updated incident',
        avatar: 'https://i.pravatar.cc/40?img=3',
        message: 'An ambulance is on its way'
      },
      {
        id: 7,
        time: '08:29',
        type: 'alert',
        author: 'Denis Murphy',
        action: 'opened incident',
        avatar: 'https://i.pravatar.cc/40?img=3',
        alert: true,
        alertType: 'danger',
        message: 'Fall in Car Park Requiring Medical Assistance\n\nA lady has fallen in the car park will possibly need some medical assistance and will also need an ambulance',
        tags: ['Health & Safety', 'Medical', 'Slip Trip Fall'],
        location: {
          address: 'Coach Park, Gateshead NE11 9DJ, UK'
        }
      }
    ]);

    const sendMessage = () => {
      if (newMessage.value.trim()) {
        timelineEvents.unshift({
          id: Date.now(),
          time: new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }),
          type: 'user',
          author: 'You',
          action: 'added comment',
          avatar: 'https://i.pravatar.cc/40?img=1',
          message: newMessage.value
        });
        newMessage.value = '';
      }
    };

    const openBlockchainDrawer = (event) => {
      selectedTransaction.value = generateBlockchainData(event.id);
      drawerOpen.value = true;
    };

    const closeBlockchainDrawer = () => {
      drawerOpen.value = false;
      selectedTransaction.value = null;
    };

    const copyToClipboard = async (text) => {
      try {
        await navigator.clipboard.writeText(text);
        // Optional: Show a toast notification
        console.log('Copied to clipboard:', text);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    };

    return {
      newMessage,
      timelineEvents,
      sendMessage,
      drawerOpen,
      selectedTransaction,
      openBlockchainDrawer,
      closeBlockchainDrawer,
      copyToClipboard
    };
  }
};
</script>

<style scoped>
.incident-timeline {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: #F2F2F7;
  min-height: 100vh;
  overflow: hidden;
}

.status-bar {
  background: #FFFFFF;
  padding: 8px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #E5E5EA;
}

.status-icons {
  display: flex;
  align-items: center;
  gap: 6px;
}

.battery-percent {
  font-size: 12px;
  font-weight: 500;
}

.header {
  background: #FFFFFF;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #E5E5EA;
}

.back-button {
  background: none;
  border: none;
  padding: 0;
  margin-right: 12px;
  cursor: pointer;
}

.title {
  flex: 1;
  font-size: 17px;
  font-weight: 600;
  color: #000000;
  margin: 0;
}

.menu-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.incident-card {
  background: #FFFFFF;
  padding: 16px;
  border-bottom: 1px solid #E5E5EA;
}

.incident-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.incident-number {
  background: #007AFF;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 600;
}

.badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.badge.health-safety {
  background: #E8F5E8;
  color: #2E7D32;
}

.badge.medical {
  background: #FFF3E0;
  color: #E65100;
}

.incident-status {
  text-align: center;
  margin-bottom: 16px;
}

.status-label {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.timer {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
}

.time-block {
  background: #E3F2FD;
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  min-width: 60px;
}

.time-value {
  display: block;
  font-size: 24px;
  font-weight: 600;
  color: #000;
}

.time-label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
}

.location-button {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 50%;
  background: #F0F8FF;
}

.opened-by {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.temperature {
  margin-left: auto;
  font-size: 14px;
  color: #666;
}

.timeline-section {
  background: #FFFFFF;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.timeline-tabs {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #E5E5EA;
  background: #F8F9FA;
}

.tab {
  background: none;
  border: none;
  padding: 8px 12px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  margin-right: 8px;
}

.tab.active {
  background: #007AFF;
  color: white;
}

.message-count {
  background: #666;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  margin-left: auto;
}

.timeline-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.date-header {
  text-align: center;
  font-size: 12px;
  color: #666;
  font-weight: 500;
  margin-bottom: 16px;
  background: #F0F0F0;
  padding: 6px 12px;
  border-radius: 12px;
  display: inline-block;
  margin-left: 50%;
  transform: translateX(-50%);
}

.timeline-event {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.event-time {
  font-size: 12px;
  color: #666;
  width: 40px;
  text-align: right;
  flex-shrink: 0;
  margin-top: 4px;
}

.event-marker {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 8px;
  flex-shrink: 0;
}

.event-marker.closed {
  background: #DC3545;
}

.event-marker.update {
  background: #28A745;
}

.event-marker.medical {
  background: #FFC107;
}

.event-marker.response {
  background: #17A2B8;
}

.event-marker.alert {
  background: #DC3545;
}

.event-content {
  flex: 1;
  background: #FFFFFF;
  border-radius: 12px;
  padding: 12px;
  border: 1px solid #E5E5EA;
}

.event-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.event-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.alert-message {
  background: #FFF5F5;
  border: 1px solid #FED7D7;
  border-radius: 8px;
  padding: 12px;
  margin-top: 8px;
  display: flex;
  gap: 8px;
}

.alert-content {
  flex: 1;
}

.alert-title {
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.alert-text {
  font-size: 14px;
  color: #2D3748;
  line-height: 1.4;
}

.more-button {
  color: #007AFF;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 8px;
  display: inline-block;
}

.event-message {
  font-size: 14px;
  color: #2D3748;
  margin-top: 8px;
  line-height: 1.4;
  white-space: pre-line;
}

.event-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.tag {
  background: #E3F2FD;
  color: #1565C0;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.tag.healthsafety {
  background: #E8F5E8;
  color: #2E7D32;
}

.tag.medical {
  background: #FFF3E0;
  color: #E65100;
}

.tag.sliptripfall {
  background: #FFF8E1;
  color: #F57C00;
}

.event-location {
  margin-top: 8px;
  padding: 8px;
  background: #F8F9FA;
  border-radius: 8px;
}

.location-text {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
}

.location-address {
  font-size: 13px;
  color: #2D3748;
  margin-bottom: 8px;
}

.location-map {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.location-map img {
  width: 100%;
  height: 120px;
  object-fit: cover;
}

.map-marker {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  background: #007AFF;
  border-radius: 50%;
  border: 3px solid white;
}

.event-image {
  margin-top: 8px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.event-image img {
  width: 100%;
  height: 120px;
  object-fit: cover;
}

.image-highlight {
  position: absolute;
  width: 60px;
  height: 60px;
  border: 3px solid #DC3545;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.bottom-nav {
  background: #FFFFFF;
  border-top: 1px solid #E5E5EA;
  padding: 12px 16px;
}

.nav-input {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.nav-input input {
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #E5E5EA;
  border-radius: 20px;
  outline: none;
  font-size: 14px;
}

.attach-button, .camera-button {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
}

.nav-buttons {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.nav-button {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  position: relative;
}

.nav-button.active svg {
  color: #007AFF;
}

.nav-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #FF3B30;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  min-width: 16px;
  text-align: center;
  line-height: 1;
}

/* Blockchain Security Icon */
.blockchain-security {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #E5E5EA;
}

.blockchain-icon {
  background: none;
  border: none;
  padding: 8px 12px;
  border-radius: 20px;
  background: #F0F8FF;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
}

.blockchain-icon:hover {
  background: #E3F2FD;
  transform: translateY(-1px);
}

.blockchain-icon .security-badge {
  position: absolute;
  top: -4px;
  right: -4px;
}

/* Drawer Styles */
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
}

.blockchain-drawer {
  width: 90%;
  max-width: 400px;
  background: #FFFFFF;
  height: 100%;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  overflow-y: auto;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
}

.blockchain-drawer.drawer-open {
  transform: translateX(0);
}

.drawer-header {
  background: #F8F9FA;
  padding: 16px;
  border-bottom: 1px solid #E5E5EA;
  display: flex;
  align-items: center;
  gap: 12px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.drawer-back-button {
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.drawer-back-button:hover {
  background: #E5E5EA;
}

.drawer-title {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  margin: 0;
}

.drawer-content {
  padding: 16px;
}

.blockchain-card {
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid #E5E5EA;
  overflow: hidden;
}

.card-header {
  background: #F8F9FA;
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #E5E5EA;
}

.blockchain-icon-large {
  position: relative;
  display: inline-block;
  margin-bottom: 12px;
}

.blockchain-icon-large .security-badge-large {
  position: absolute;
  top: -8px;
  right: -8px;
}

.card-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin: 0;
}

.transaction-details {
  padding: 20px;
}

.detail-item {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #F0F0F0;
}

.detail-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.detail-item label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #666;
  margin-bottom: 8px;
}

.detail-item span {
  display: block;
  font-size: 14px;
  color: #2D3748;
  line-height: 1.4;
}

.address-text, .hash-text {
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  font-size: 12px;
  background: #F8F9FA;
  padding: 8px 12px;
  border-radius: 8px;
  word-break: break-all;
  margin-bottom: 8px;
  border: 1px solid #E5E5EA;
  position: relative;
  padding-right: 40px;
}

.copy-button {
  background: none;
  border: none;
  position: absolute;
  top: 8px;
  right: 8px;
  padding: 4px;
  cursor: pointer;
  color: #666;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.copy-button:hover {
  background: #E5E5EA;
  color: #007AFF;
}

.certificate-container {
  background: #F8F9FA;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #E5E5EA;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.certificate-icon {
  flex-shrink: 0;
  padding: 8px;
  background: #E3F2FD;
  border-radius: 8px;
}

.certificate-info {
  flex: 1;
}

.certificate-name {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2D3748;
  margin-bottom: 4px;
}

.certificate-issuer, .certificate-expires {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 2px;
}

.security-status {
  background: #E8F5E8;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #C8E6C9;
  margin-top: 20px;
}

.security-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.security-indicator span {
  font-size: 14px;
  font-weight: 600;
  color: #2E7D32;
}

.security-description {
  font-size: 12px;
  color: #2E7D32;
  line-height: 1.4;
  margin: 0;
}
</style>